/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SuggestionActionViewTeamDashboard_payload = {
    readonly __typename: "SuggestionActionViewTeamDashboardPayload";
    readonly " $refType": "SuggestionActionViewTeamDashboard_payload";
} | {
    /*This will never be '%other', but we need some
    value in case none of the concrete values match.*/
    readonly __typename: "%other";
    readonly " $refType": "SuggestionActionViewTeamDashboard_payload";
};
export type SuggestionActionViewTeamDashboard_payload$data = SuggestionActionViewTeamDashboard_payload;
export type SuggestionActionViewTeamDashboard_payload$key = {
    readonly " $data"?: SuggestionActionViewTeamDashboard_payload$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SuggestionActionViewTeamDashboard_payload">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SuggestionActionViewTeamDashboard_payload",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
        }
    ],
    "type": "SuggestionActionViewTeamDashboardPayload",
    "abstractKey": null
} as any;
(node as any).hash = 'cf7671a5bbfe39db4a382ad3dd2e4a49';
export default node;
